interface CommonProps {
  size?: string;
  color?: string;
}

export const CalendarAddIcon = ({ size, color }: CommonProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '24'}
      height={size || '24'}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.5 22.2861H3.64286C2.8736 22.2861 2.25 21.6625 2.25 20.8933V4.17899C2.25 3.40974 2.8736 2.78613 3.64286 2.78613H20.3571C21.1264 2.78613 21.75 3.40974 21.75 4.17899V12.5"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="8.57227"
        y1="0.75"
        x2="8.57227"
        y2="4.82143"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="15.5361"
        y1="0.75"
        x2="15.5361"
        y2="4.82143"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line x1="2" y1="8.25" x2="21.5" y2="8.25" stroke={color || '#404040'} strokeWidth="1.5" />
      <line
        x1="15.75"
        y1="19.0498"
        x2="22.65"
        y2="19.0498"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="19.35"
        y1="15.75"
        x2="19.35"
        y2="22.65"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CalendarDayIcon = ({ size, color }: CommonProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '24'}
      height={size || '24'}
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="1.99902"
        y="2.78516"
        width="19.5"
        height="19.5"
        rx="1.39286"
        stroke={color || '#404040'}
        strokeWidth="1.5"
      />
      <line
        x1="8.31934"
        y1="0.75"
        x2="8.31934"
        y2="4.82143"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="15.2842"
        y1="0.75"
        x2="15.2842"
        y2="4.82143"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="1.99902"
        y1="8.25"
        x2="21.499"
        y2="8.25"
        stroke={color || '#404040'}
        strokeWidth="1.5"
      />
      <path
        d="M10.0386 12.5566L11.9615 11.1504V18.6504"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalendarMonthIcon = ({ size, color }: CommonProps) => {
  return (
    <svg
      width={size || '24'}
      height={size || '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.99902"
        y="2.78516"
        width="19.5"
        height="19.5"
        rx="1.39286"
        stroke={color || '#404040'}
        strokeWidth="1.5"
      />
      <line
        x1="8.31934"
        y1="0.75"
        x2="8.31934"
        y2="4.82143"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="15.2842"
        y1="0.75"
        x2="15.2842"
        y2="4.82143"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="1.99902"
        y1="8.25"
        x2="21.499"
        y2="8.25"
        stroke={color || '#404040'}
        strokeWidth="1.5"
      />
      <path
        d="M8.97756 14.9309C9.00128 14.9309 9.50106 14.9312 9.52462 14.9318C10.8066 14.9618 11.8344 15.8028 11.8344 16.8358C11.8344 17.8879 10.7685 18.7407 9.4537 18.7407C8.32614 18.7407 7.38166 18.1135 7.1355 17.2713"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.01229 14.8104C9.03452 14.8104 9.50271 14.8101 9.52478 14.8096C10.7258 14.7815 11.6886 13.9935 11.6886 13.0255C11.6886 12.0398 10.6901 11.2407 9.45834 11.2407C8.53451 11.2407 7.74187 11.6902 7.40332 12.3309"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.1838 12.6152L16.0634 11.2407V18.5711"
        stroke={color || '#404040'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalendarWeekIcon = ({ size, color }: CommonProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '16'}
      height={size || '16'}
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect
        x="1.33264"
        y="1.85693"
        width="13"
        height="13"
        rx="0.928571"
        stroke={color || '#404040'}
        strokeWidth="1.2"
      />
      <line
        x1="5.64614"
        y1="0.6"
        x2="5.64614"
        y2="3.11429"
        stroke={color || '#404040'}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="10.2895"
        y1="0.6"
        x2="10.2895"
        y2="3.11429"
        stroke={color || '#404040'}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="1.33264"
        y1="5.4"
        x2="14.3326"
        y2="5.4"
        stroke={color || '#404040'}
        strokeWidth="1.2"
      />
      <path
        d="M6.26465 8H9.2704L7.5 12.5"
        stroke={color || '#404040'}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalendarRotateIcon = ({ size, color }: CommonProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '16'}
      height={size || '16'}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_338_456)">
        <path
          d="M14 8.75743C13.8095 10.2106 13.096 11.5445 11.993 12.5095C10.89 13.4745 9.47307 14.0044 8.00754 14C6.54201 13.9956 5.12832 13.4572 4.03109 12.4857C2.93386 11.5141 2.22832 10.1759 2.04654 8.72168C1.86477 7.26742 2.21921 5.79676 3.04353 4.585C3.86786 3.37323 5.10554 2.50344 6.52489 2.13843C7.94425 1.77343 9.44798 1.93824 10.7546 2.60201C12.0612 3.26579 13.0811 4.38302 13.6234 5.74457M14 1.97849L14 5.74457L10.234 5.74457"
          stroke={color || '#404040'}
          strokeWidth="1.35577"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_338_456">
          <rect width="16" height="16" fill="white" transform="matrix(-1 0 0 1 16 0)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CalendarNormalIcon = ({ size, color }: CommonProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '16'}
      height={size || '16'}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M15 1.40625H11.7188V0.15625C11.7188 0.0703125 11.6484 0 11.5625 0H10.4688C10.3828 0 10.3125 0.0703125 10.3125 0.15625V1.40625H5.3125V0.15625C5.3125 0.0703125 5.24219 0 5.15625 0H4.0625C3.97656 0 3.90625 0.0703125 3.90625 0.15625V1.40625H0.625C0.279297 1.40625 0 1.68555 0 2.03125V15C0 15.3457 0.279297 15.625 0.625 15.625H15C15.3457 15.625 15.625 15.3457 15.625 15V2.03125C15.625 1.68555 15.3457 1.40625 15 1.40625ZM14.2188 14.2188H1.40625V6.79688H14.2188V14.2188ZM1.40625 5.46875V2.8125H3.90625V3.75C3.90625 3.83594 3.97656 3.90625 4.0625 3.90625H5.15625C5.24219 3.90625 5.3125 3.83594 5.3125 3.75V2.8125H10.3125V3.75C10.3125 3.83594 10.3828 3.90625 10.4688 3.90625H11.5625C11.6484 3.90625 11.7188 3.83594 11.7188 3.75V2.8125H14.2188V5.46875H1.40625Z"
        fill={color || '#404040'}
      />
    </svg>
  );
};

export const CalendarDeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M5 7H18L17 20H6L5 7Z" stroke="#404040" strokeWidth="1.3" strokeLinejoin="round" />
      <path
        d="M9.23071 10L9.76918 17"
        stroke="#404040"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5386 10L13.0001 17"
        stroke="#404040"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3 7H20" stroke="#404040" strokeWidth="1.3" strokeLinecap="round" />
      <path
        d="M16 7V5C16 4.44772 15.5523 4 15 4H8C7.44772 4 7 4.44772 7 5V7"
        stroke="#404040"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalendarCheckIcon = ({ color }: CommonProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
      <path
        d="M1 5L5.70588 10L15 1"
        stroke={color || 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
